export default __webpack_public_path__ + "static/media/PhotosGallery.tsx.25ccef9f.txt";